import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';

/**
 * Create the setResult method.
 */
export function createSetResult(context: API.Context) {
  /**
   * Sets the `Result` header via the setGameDetails API method.
   */
  return function setResult(result: Game.Results): API.Response | null {
    const { api } = context;

    return api.setGameDetails({ Result: result });
  };
}
